import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserSessionDto } from '../models/userSession/userSessionDto';
import { UserSessionStatsDto } from '../models/userSession/userSessionStatsDto';
import DeviceDetector from 'device-detector-js';

@Injectable({
  providedIn: 'root',
})
export class UserSessionService {
  private API = '/api/userSession';
  private deviceDetector = new DeviceDetector();

  constructor(private http: HttpClient) {}

  private async getDeviceInfo(): Promise<{
    deviceType: string;
    device: string;
    browser: string;
    os: string;
  }> {
    const result = this.deviceDetector.parse(navigator.userAgent);

    const deviceType =
      result.device?.type === 'smartphone' || result.device?.type === 'tablet'
        ? 'Mobile'
        : 'Desktop';

    const device =
      [result.device?.brand, result.device?.model].filter(Boolean).join(' ') ||
      'Unknown';

    const browser = result.client?.name || 'Unknown';

    let os =
      [result.os?.name, result.os?.version].filter(Boolean).join(' ') ||
      'Unknown';

    // Ось тут вставляєш кастинг і уточнення ОС
    if ((navigator as any).userAgentData) {
      try {
        const ua = await (navigator as any).userAgentData.getHighEntropyValues([
          'platformVersion',
        ]);
        const majorVersion = parseInt(ua.platformVersion.split('.')[0], 10);
        if (result.os?.name === 'Windows') {
          os = majorVersion >= 13 ? 'Windows 11' : 'Windows 10';
        }
      } catch (e) {
        console.warn('Unable to get high entropy values', e);
      }
    }

    return { deviceType, device, browser, os };
  }

  createSessionWithLocation(): Observable<UserSessionDto> {
    return from(this.getDeviceInfo()).pipe(
      switchMap((deviceInfo) =>
        from(fetch('https://ipapi.co/json/').then((res) => res.json())).pipe(
          switchMap((loc: any) => {
            const location =
              loc?.city && loc?.country_name
                ? `${loc.city}, ${loc.country_name}`
                : '';

            const ip = loc?.ip || ''; // Ось тут IP

            const session: UserSessionDto = {
              createdAt: new Date(),
              deviceType: deviceInfo.deviceType,
              device: `${deviceInfo.device} (${deviceInfo.os})`,
              browser: deviceInfo.browser,
              location,
              ip, // додаємо IP сюди
            };

            return this.http.post<UserSessionDto>(
              `${this.API}/session`,
              session
            );
          })
        )
      )
    );
  }

  getSessionStats(): Observable<UserSessionStatsDto[]> {
    return this.http.get<UserSessionStatsDto[]>(`${this.API}/session`);
  }

  getSessionForUserStats(userId: string): Observable<UserSessionStatsDto[]> {
    return this.http.get<UserSessionStatsDto[]>(
      `${this.API}/session/${userId}`
    );
  }
}
